import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  Phone: {
    id: 'label_phone',
    defaultMessage: 'Phone',
  },
  Email: {
    id: 'label_email',
    defaultMessage: 'E-Mail',
  },
  Date: {
    id: 'label_date',
    defaultMessage: 'Date',
  },
  Duration: {
    id: 'label_duration',
    defaultMessage: 'Duration',
  },
  SchoolDays: {
    id: 'label_school_days',
    defaultMessage: 'School days',
  },
  Place: {
    id: 'label_place',
    defaultMessage: 'Place',
  },
  CourseManagement: {
    id: 'label_course_management',
    defaultMessage: 'Course management',
  },
  ApplicationStart: {
    id: 'label_application_start',
    defaultMessage: 'Application start',
  },
  FinalApplicationDate: {
    id: 'label_final_application_date',
    defaultMessage: 'Final application date',
  },
  NumberOfSeats: {
    id: 'label_number_of_seats',
    defaultMessage: 'Number of seats',
  },
  AvailableSeats: {
    id: 'label_available_seats',
    defaultMessage: 'Available seats',
  },
  Notes: {
    id: 'label_notes',
    defaultMessage: 'Notes',
  },
  RegisterFrom: {
    id: 'label_register_from',
    defaultMessage: 'Register from {date}',
  },
  WaitingList: {
    id: 'label_waiting_list',
    defaultMessage: 'Waiting list',
  },
  Register: {
    id: 'label_register',
    defaultMessage: 'Register',
  },
  NoRegistrationRequired: {
    id: 'label_no_registration_required',
    defaultMessage: 'No registration required',
  },
  NextStart: {
    id: 'label_next_start',
    defaultMessage: 'Next start',
  },
  InfoItemList: {
    id: 'value_info_item_list',
    defaultMessage: '{items}, {last}',
  },
  StudyMode: {
    id: 'label_study_mode',
    defaultMessage: 'Studying mode',
  },
  LanguageUsed: {
    id: 'label_language',
    defaultMessage: 'Language used',
  },
  TeachingLanguage: {
    id: 'label_teaching_language',
    defaultMessage: 'Teaching language',
  },
  Venue: {
    id: 'label_venue',
    defaultMessage: 'Place',
  },
  EducationFormat: {
    id: 'label_education_format',
    defaultMessage: 'Education format',
  },
  TargetAudience: {
    id: 'label_target_audience',
    defaultMessage: 'Target audience',
  },
  CostAbsorption: {
    id: 'label_cost_absorption',
    defaultMessage: 'Cost absorption',
  },
  ScheduleMeeting: {
    id: 'label_schedule_meeting',
    defaultMessage: 'Schedule a meeting',
  },
  ShowOnMap: {
    id: 'label_show_on_map',
    defaultMessage: 'Show on map',
  },
  RollingIntake: {
    id: 'label_rolling_intake',
    defaultMessage: 'Rolling intake possible',
  },
  ImportToCalendar: {
    id: 'label_import_to_calendar',
    defaultMessage: 'Import to calendar (iCal)',
  },
  Type: {
    id: 'label_type',
    defaultMessage: 'Type',
  },
  Fee: {
    id: 'label_fee',
    defaultMessage: 'Fee',
  },
  Format: {
    id: 'label_format',
    defaultMessage: 'Format',
  },
  Institution: {
    id: 'label_institution',
    defaultMessage: 'Institute',
  },
  School: {
    id: 'label_school',
    defaultMessage: 'School',
  },
  Newstype: {
    id: 'label_newstype',
    defaultMessage: 'News type',
  },
  ResearchField: {
    id: 'label_research_field',
    defaultMessage: 'Research field',
  },
  Details: {
    id: 'label_details',
    defaultMessage: 'Details about the event',
  },
  Participate: {
    id: 'label_participate',
    defaultMessage: 'Participation',
  },
});
